import { type AnimationStep } from './AnimationPlayer';
import { CameraMover } from '../CameraMover';
import type { CameraTargetProps } from '../../types';

export interface CameraMovementAnimationStepProps {
  cameraTarget: CameraTargetProps;
  transitionTime: number;
}

export const CameraMovementAnimationStep = (
  cameraMover: CameraMover,
  stepProps: CameraMovementAnimationStepProps
): AnimationStep => {
  const { cameraTarget, transitionTime } = stepProps;
  return {
    startStep: (onComplete: () => void) => {
      cameraMover.moveCameraToTargetProps({ ...cameraTarget, transitionTime, onComplete });
    },
  };
};
